import { type InfiniteData } from '@tanstack/react-query';

import { type AxiosCompatibleResponse } from '../http/types';

import { type PaginatedResponse } from './types';

/**
 * Unpack a paginated infinite query response into a flat
 * array of the items contained in all pages.
 */
export function getObjectsFromPages<T>(
  pages?: InfiniteData<AxiosCompatibleResponse<PaginatedResponse<T>>>
): Array<T> {
  if (!pages) {
    return [];
  }

  return pages.pages.flatMap((page) => page.data.objects);
}
